import { Box, Stack, Typography } from '@mui/material';

import { Callout } from '@/components/notifications/Callout/Callout';

interface HypotheticalWaterfallScenarioCalloutProps {
  waterfallName: string;
  /** Defaults to "Hypothetical dispositions" (DP form). */
  title?: string;
  /**
   * Text rendered before the bolded "are only applied to..." clause.
   * Defaults to "Dispositions for this entity" (DP form).
   */
  bodyPrefix?: string;
}

export function HypotheticalWaterfallScenarioCallout({
  waterfallName,
  title = 'Hypothetical dispositions',
  bodyPrefix = 'Dispositions for this entity',
}: HypotheticalWaterfallScenarioCalloutProps) {
  return (
    <Box mb={2}>
      <Callout severity="warning">
        <Stack spacing={0.5}>
          <Typography variant="title-xs">{title}</Typography>
          <Typography variant="body-xs">
            {bodyPrefix} <b>are only applied to this hypothetical waterfall</b>{' '}
            &quot;
            {waterfallName}&quot;
          </Typography>
        </Stack>
      </Callout>
    </Box>
  );
}
